import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import PropTypes from "prop-types";
import MemberUserController from "./Controller/member_user_controller.ts";
import { notification } from "antd";
import { useSearchParams } from "react-router-dom";
import { HolderOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button as Buttons, Table } from "antd";
import InvoiceController from "./Controller/invoice_controller.ts";
import ExamplePopper from "../../components/TextInput/Popper.js";
import Paper from "@mui/material/Paper";
import { TextField } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableMUI from "@mui/material/Table";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { BlobProvider } from "@react-pdf/renderer";
import MyDocument from "./pdf/membership-invoice.tsx";
import Stack from "@mui/material/Stack";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// ------------------ DRAGABBLE TABLE ------------------------------------------------------------
const RowContext = React.createContext({});
const DragHandle = () => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext);
  return (
    <Buttons
      type="text"
      size="small"
      icon={<HolderOutlined />}
      style={{
        cursor: "move",
      }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

const Row = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props["data-row-key"],
  });
  const style = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging
      ? {
          position: "relative",
          zIndex: 9999,
        }
      : {}),
  };
  const contextValue = useMemo(
    () => ({
      setActivatorNodeRef,
      listeners,
    }),
    [setActivatorNodeRef, listeners]
  );
  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  );
};

// ------------------ DRAGABBLE TABLE ------------------------------------------------------------

const Dashboard = () => {
  // expand button
  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  // notification
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, msg) => {
    api[type]({
      message: msg,
      description: desc,
    });
  };

  const [shouldRefetchData, setShouldRefetchData] = useState(false);
  const [data, setData] = useState([]); //payment is default during registration eg: registration fee & first year annual subscription fee

  const [searchParams] = useSearchParams();
  const paymentID = searchParams.get("paymentID");
  const contractID = searchParams.get("contractID");
  const [total, setTotal] = useState(0); // State for total
  useEffect(() => {
    const payload = { paymentID: paymentID, contractID: contractID };

    InvoiceController.getMembershipInvoiceInfo(payload)
      .then((response) => {
        setData(response);
        console.log(response);
        const amountsArray = response.amounts.split(",").map(Number); // Convert to numbers
        console.log(amountsArray);
        const row_array = response.fees.map((item, index) => {
          return {
            key: index,
            member_feeID: item.member_feeID,
            label: item.label,
            description: item.description,
            amount: amountsArray[index]
              ? amountsArray[index].toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : amountsArray[index],
          };
        });
        setDataSource(row_array);

        setTotal(response.total_amounts); // Update total with calculated value
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [paymentID, contractID, shouldRefetchData]);

  //   ---------------------- TABLE --------------------------------------------------------------
  const columns = [
    {
      key: "sort",
      align: "center",
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: "Item",
      dataIndex: "label",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Qty.",
      dataIndex: "address",
    },
    {
      title: "Price",
      dataIndex: "amount",
    },
    {
      title: "Tax Rate",
      dataIndex: "address",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
  ];

  const [dataSource, setDataSource] = React.useState([]);
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setDataSource((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id
        );
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });
    }
  };

  //   ------------------------ TABLE --------------------------------------------------------------

  //   ------------------------- POPPER -------------------------------------------------------------
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);

  const handleFocusInput = () => {
    setIsOpen(true);
  };

  const handleBlurInput = () => {
    setIsOpen(false);
  };
  //   ------------------------- POPPER -------------------------------------------------------------

  const formatIssueDate = (dateString) => {
    const date = new Date(dateString);

    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formatDueDate = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + 14);

    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  // ------------------------- POPPER --------------------------------------------------------------

  const openPdfPreview = (url) => {
    // Open the PDF in a new tab
    const newWindow = window.open(url, "_blank");
    if (!newWindow) {
      alert("Please allow popups for this website to preview the PDF.");
    }
  };

  //   const date = data.payment_datetime_created.split(" ")[0]; // Extracts "2025-01-14"
  console.log(data);
  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: expanded ? "300vh" : "100vh",
        width: "100vw",
        flexDirection: "column", // Ensure stacking of children vertically
      }}
    >
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pl: 3,
          pr: 3,
        }}
      >
        <DrawerHeader />
        {contextHolder}

        <Stack sx={{ height: 80, padding: 2 }} component={Paper} spacing={2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center", // Align items vertically
              justifyContent: "space-between", // Optional: Space between components
              gap: 2, // Optional: Add spacing between components
              marginTop: 2,
            }}
          >
            <Typography variant="h5">Invoice {data.invoice_no}</Typography>
            <BlobProvider
              document={
                <MyDocument
                  paymentID={data.paymentID}
                  company_name={data.company_name}
                  email={data.email}
                  date_time={data.payment_datetime_created}
                  date={data.payment_datetime_created}
                  address={data.address}
                  contact_name={data.contact_name}
                  memberID={data.memberID}
                  payment_item={data.payment_item}
                  invoice_no={data.invoice_no}
                  fee_amounts={data.amounts}
                />
              }
            >
              {({ blob, url, loading }) =>
                loading ? (
                  "Generating PDF..."
                ) : (
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#d33333",
                      "&:hover": {
                        backgroundColor: "#b02e2e", // Darker red on hover
                        boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)", // Larger shadow on hover
                      },
                    }}
                    startIcon={<VisibilityIcon />}
                    onClick={() => openPdfPreview(url)}
                  >
                    Preview
                  </Button>
                )
              }
            </BlobProvider>
          </Box>
        </Stack>

        <CardContent>
          <Grid container spacing={2}>
            <Grid size={3}>
              <Typography variant="h6">To</Typography>
            </Grid>
            <Grid size={3}>
              <Typography variant="h6">Issue Date</Typography>
            </Grid>
            <Grid size={3}>
              <Typography variant="h6">Due Date</Typography>
            </Grid>
            <Grid size={3}>
              <Typography variant="h6">Invoice Number</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ paddingBottom: 2 }}>
            <Grid size={3}>
              <TextField
                ref={inputRef}
                sx={{
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "16px",
                    borderRadius: "25px",
                    color: "black", // Set the input text color to black
                    backgroundColor: "white", // Set background color to white
                    "& fieldset": {
                      borderColor: "#ccc", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#999", // Border color on hover
                    },
                    // "&.Mui-focused fieldset": {
                    //   borderColor: "transparent", // Border color on focus
                    //   outline: "none", // Remove outline on focus
                    // },
                  },
                }}
                slotProps={{
                  input: {
                    readOnly: true, // Makes the field readonly
                  },
                }}
                value={data.contact_name}
                onFocus={handleFocusInput}
                onBlur={handleBlurInput}
              />

              <ExamplePopper open={isOpen} anchorEl={inputRef.current}>
                <Paper>
                  <Typography sx={{ p: 2 }}>
                    <EmailIcon /> {data.contact_email}
                  </Typography>
                  <Typography sx={{ p: 2 }}>
                    <LocationOnIcon /> {data.correspondence_address}
                  </Typography>
                  <Typography sx={{ p: 2 }}>
                    <CallIcon /> {data.telephone_no}
                  </Typography>
                </Paper>
              </ExamplePopper>
            </Grid>
            <Grid size={3}>
              <TextField
                sx={{
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "16px",
                    borderRadius: "25px",
                    color: "black", // Set the input text color to black
                    backgroundColor: "white", // Set background color to white
                    "& fieldset": {
                      borderColor: "#ccc", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#999", // Border color on hover
                    },
                    // "&.Mui-focused fieldset": {
                    //   borderColor: "transparent", // Border color on focus
                    //   outline: "none", // Remove outline on focus
                    // },
                  },
                }}
                slotProps={{
                  input: {
                    readOnly: true, // Makes the field readonly
                  },
                }}
                value={formatIssueDate(data.payment_datetime_created)}
              />
            </Grid>
            <Grid size={3}>
              <TextField
                sx={{
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "16px",
                    borderRadius: "25px",
                    color: "black", // Set the input text color to black
                    backgroundColor: "white", // Set background color to white
                    "& fieldset": {
                      borderColor: "#ccc", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#999", // Border color on hover
                    },
                    // "&.Mui-focused fieldset": {
                    //   borderColor: "transparent", // Border color on focus
                    //   outline: "none", // Remove outline on focus
                    // },
                  },
                }}
                slotProps={{
                  input: {
                    readOnly: true, // Makes the field readonly
                  },
                }}
                value={formatDueDate(data.payment_datetime_created)}
              />
            </Grid>
            <Grid size={3}>
              <TextField
                sx={{
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "16px",
                    borderRadius: "25px",
                    color: "black", // Set the input text color to black
                    backgroundColor: "white", // Set background color to white
                    "& fieldset": {
                      borderColor: "#ccc", // Default border color
                    },
                    "&:hover fieldset": {
                      borderColor: "#999", // Border color on hover
                    },
                    // "&.Mui-focused fieldset": {
                    //   borderColor: "transparent", // Border color on focus
                    //   outline: "none", // Remove outline on focus
                    // },
                  },
                }}
                slotProps={{
                  input: {
                    readOnly: true, // Makes the field readonly
                  },
                }}
                value={data.invoice_no}
              />
            </Grid>
          </Grid>
        </CardContent>

        <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
          <SortableContext
            items={dataSource.map((i) => i.key)}
            strategy={verticalListSortingStrategy}
          >
            <Table
              rowKey="key"
              components={{
                body: {
                  row: Row,
                },
              }}
              columns={columns}
              dataSource={dataSource}
            />
          </SortableContext>
        </DndContext>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <TableContainer sx={{ width: "40%" }} component={Paper}>
            <TableMUI aria-label="spanning table">
              <TableBody>
                <TableRow>
                  <TableCell>Total Excl.SST (RM)</TableCell>
                  <TableCell align="right">
                    {total.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>SST 8%</TableCell>
                  <TableCell align="right">0.00</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Total</TableCell>
                  <TableCell align="right">
                    {total.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                </TableRow>
              </TableBody>
            </TableMUI>
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
